import { render, staticRenderFns } from "./CompanySetting.vue.vue?vue&type=template&id=d5cf2510&"
import script from "./CompanySetting.vue.vue?vue&type=script&lang=js&"
export * from "./CompanySetting.vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports